module.exports = __webpack_public_path__ + "assets/img/btn-back-5e16a224.png";